import { Socket, SocketIoConfig } from 'ngx-socket-io';

export class SocketNameSpace extends Socket {
  constructor(url: string, namespace: string, uuid: string) {
    const socketConfig: SocketIoConfig = { url };
    socketConfig.options = { query: { uuid } };
    // Required for loadbalancer
    socketConfig.options.withCredentials = true;
    // Handle paths here
    const uri = new URL(url);
    socketConfig.url = `${uri.protocol}//${uri.host}/${namespace}`;
    socketConfig.options.path = ('/' === uri.pathname ? '' : uri.pathname) +'/socket.io';
    super(socketConfig);
  }
}
